import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'
import { Store } from '../store/index.js'

import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

Vue.use(VueRouter)

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function (/* { store, ssrContext } */) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE
  })

  // Re-route authenticated pages to login if no JWT is present
  Router.beforeEach((to, from, next) => {
    const jwt = Store.state.user.token
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (jwt == null) {
        next({ path: '/login', query: { nextUrl: to.fullPath } })
        /* next({
          path: '/login',
          query: { nextUrl: to.fullPath }
        }) */
      } else {
        next()
      }
    } else {
      next()
    }
  })

  Router.afterEach((to, from, next) => {
    if (!to.params.moduleId) {
      Store.dispatch('app/selectModule', null)
    }
  })

  if (process.env.PROD || process.env.ENABLE_SENTRY) {
    Sentry.init({
      Vue,
      dsn: 'https://824558e56f104e648f9e53a85113bb3b@o1316930.ingest.sentry.io/6569853',
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(Router),
          tracingOrigins: ['localhost', '.*\\.pethau\\.io', '.*\\.evometric\\.cloud', /^\//]
        })
      ],
      logErrors: true,
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0
    })
  }

  return Router
}
